import { extend } from 'quasar'

const settings = {
  type: null,
  title: 'Widget sin Título',
  options: {}
}

class Widget {
  constructor (_widget) {
    if (typeof _widget !== 'undefined') {
      this.id = _widget.id ? _widget.id : null
      this.user_id = _widget.user_id ? _widget.user_id : null
      this.dashboard_id = _widget.dashboard_id ? _widget.dashboard_id : null
      this.order = _widget.order ? _widget.order : 0
      this.settings = _widget.settings ? extend(true, {}, _widget.settings) : settings
      this.last_result = _widget.last_result ? _widget.last_result : null
      this.last_fetched = _widget.last_fetched ? _widget.last_fetched : null
    } else {
      this.id = null
      this.user_id = null
      this.dashboard_id = null
      this.order = 0
      this.settings = settings
      this.last_result = null
      this.last_fetched = null
    }
  }
}

export default Widget
